/**
 * WhatsApp Communication utility functions
 */

/**
 * Parses comma/semicolon/space-separated input and validates Indian mobile format.
 * Valid: 10 digits starting with 6-9, or 12 digits starting with 91.
 * Returns valid numbers in E.164 format (91XXXXXXXXXX).
 *
 * @param {string} input - Raw input string (e.g. "9876543210, 91 9123456789")
 * @returns {{ valid: string[], invalid: string[] }} Valid numbers (91-prefixed) and invalid entries
 *
 * @example
 * parseAndValidatePhoneNumbers('9876543210, 9123456789') // { valid: ['919876543210', '919123456789'], invalid: [] }
 * parseAndValidatePhoneNumbers('1234567890') // { valid: [], invalid: ['1234567890'] }
 */
export function parseAndValidatePhoneNumbers(input) {
  const raw = (input || '')
    .split(/[,;\s]+/)
    .map((s) => s.trim())
    .filter(Boolean);

  const valid = [];
  const invalid = [];

  for (const s of raw) {
    const digits = s.replace(/\D/g, '');
    const isValid =
      (digits.length === 10 && /^[6-9]/.test(digits)) ||
      (digits.length === 12 && digits.startsWith('91'));
    if (isValid) {
      valid.push(digits.length === 10 ? `91${digits}` : digits);
    } else {
      invalid.push(s);
    }
  }

  return { valid, invalid };
}
